import { to } from '@tencent/wphk-base-utils';
import { defineStore } from 'pinia';
import { isTargetSpId, isValidActType, loadConfig } from '../business';
import { MainlandActConfig } from '../types';

export const useActConfigStore = defineStore({
  id: 'mainlandActConfig',
  state: () => ({
    allActConfig: [] as MainlandActConfig[],
    targetActConfig: undefined as MainlandActConfig | undefined,
  }),
  actions: {
    async init({ actType, spId }: { actType: string, spId: string })  {
      const [err, res] = await to(loadConfig());
      if (err || !res) {
        throw err;
      }
      this.allActConfig = res;
      this.targetActConfig = res.find(item => isValidActType(item, actType) && isTargetSpId(item, spId));
    },
  },
});
